module.exports = __webpack_public_path__ + "b8866e9b3f42da49448a714ace82a17e.svg";